export enum Mode {
    DESKTOP = 'desktop',
    MOBILE = 'mobile'
}